import { render } from "./squiggle-divider.vue?vue&type=template&id=89ca363e&scoped=true"
const script = {}

import "./squiggle-divider.vue?vue&type=style&index=0&id=89ca363e&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ca363e"]])

export default __exports__